import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type VerificationId = Branded<string, "VerificationId">;
const verificationIdPrefix = "verification__";
const {
    factory: verificationIdFactory,
    assert: isVerificationId,
    zodSchema: verificationIdZodSchema,
} = genericId<VerificationId>(verificationIdPrefix);

export {
    isVerificationId,
    verificationIdFactory,
    verificationIdPrefix,
    verificationIdZodSchema,
};
export type { VerificationId };
